// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"eebcee51","491":"10e568f4","714":"eebcee51","858":"1c09fd3b"}[chunkId] + ".chunk.css";
};